import { StorageInterface } from "./StorageInterface";
import { SessionStorageDriver } from "./Drivers/SessionStorageDriver";

class Storage {

  constructor(private driver: StorageInterface) {

  }

  public getInstant(key): string {
    return this.driver.getInstant(key);
  }

  public get(key): Promise<string> {
    return this.driver.get(key);
  }

  public set(key, value): Promise<string> {
    return this.driver.set(key, value);
  }

  public remove(key): Promise<string> {
    return this.driver.remove(key);
  }

  public clear(): Promise<any> {
    return this.driver.clear();
  }
}

export default new Storage(new SessionStorageDriver());
